import type { ReactNode } from 'react'

/**
 * `div.strip` → `strip` (process/08-COMPONENT-CATALOGUE.md). "The full-width banner above a
 * panel." The prototype draws `.strip.ok` and `.strip.warn` on some instances, but no CSS rule
 * exists for either — the catalogue's "Mapped" table carries one `strip` pattern, no variant —
 * so this component has none either; `ok`/`warn` were inert classes in the prototype.
 *
 * background var(--strip); border 1px solid var(--bd) (width not a token family); border-radius
 * 4px → --r-2; padding 9px 12px → --sp-5 / --sp-6 (both 0 delta); font-size 12px → --fs-body (0
 * delta); line-height 1.55 → --lh-normal (-0.05 delta).
 */
export function Strip({ children }: { children: ReactNode }) {
  return (
    <div data-cmp="strip" className="bg-strip border border-bd rounded-2 py-5 px-6 text-body text-tx2 leading-normal">
      {children}
    </div>
  )
}
